<template>
    <section
        class="fixed inset-0 flex items-center justify-center z-[31] bg-black bg-opacity-30 backdrop-blur-sm mt-[70px]">
        <div v-if="showModal" class="absolute inset-0 bg-black bg-opacity-50" @click="closeModal"></div>
        <div id="modal modal-customer"
            class="modal absolute block w-5/6 sm:w-9/12 md:w-5/12 bg-white shadow-md rounded-lg" :class="{
                'animate__animated animate__zoomIn': showModal,
                'animate__animated animate__zoomOut': !showModal,
            }">
            <div id="modal-header" class="w-full bg-primary dark:bg-dark-600 py-3 rounded-t-lg">
                <h5 class="text-white text-center font-bold text-xl">Cash Register</h5>
            </div>
            <div id="modal-body" class="p-5 dark:bg-dark-900">
                <InputRupiah v-model="saldo" id="saldo-awal" :label="label" input_class="w-full" />
            </div>
            <div class="modal-footer p-5 dark:bg-dark-900">
                <div class="flex justify-center">
                    <SubmitButton id="close" button_name="Close"
                        button_class="mx-1 border border-primary bg-white dark:bg-dark-800 dark:border-dark-100 hover:bg-hover-danger hover:border-white hover:text-white text-primary dark:text-white"
                        @click="closeModal" />
                    <Button type="submit" label="Posting" :loading="loading" @click="submitCashRegister()" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import InputRupiah from '@/components/form/InputRupiah.vue';
    import SubmitButton from '@/components/form/SubmitButton.vue';
    import Button from 'primevue/button';
    import { mapActions } from 'vuex';

    export default {
        name: "ModalCashRegister",
        props: {
            label: {
                type: String,
                default: 'Saldo Awal',
            },
            isOpen: {
                type: Boolean,
                default: false,
            },
            relevantCashRegister: {
                type: Object,
                default: () => ({}),
            },
        },
        components: {
            // Add any components used in the template
            InputRupiah, SubmitButton, Button
        },
        data() {
            return {
                loading: false,
                saldo: 0,
                showModal: true,
            };
        },
        created() {
            console.log('modal is live');
        },
        methods: {
            ...mapActions("cash_registers", [
                'createCashRegister',
                'closeCashRegister',
            ]),
            closeModal() {
                this.showModal = false;
                setTimeout(() => {
                    this.$emit('closeModal');
                }, 200);
            },
            submitCashRegister() {
                // this.isOpen = !this.isOpen;
                try {
                    if (!this.isOpen) {
                        this.startCashRegister(this.saldo);
                    } else {
                        this.stopCashRegister(this.saldo);
                    }
                    this.$emit('refreshCashRegister');
                    this.closeModal();
                } catch (error) {
                    console.log(error);

                    this.emit("show-dialog", error.response.data.message);
                    this.$toast.add({
                        severity: "error",
                        summary: "Failed",
                        detail: error.response.data.message,
                        life: 5000,
                    });
                }
            },
            async startCashRegister(saldo) {
                try {
                    this.loading = true;
                    this.initialBalance = parseInt(saldo);

                    await this.createCashRegister({
                        // start_by: DataTypes.INTEGER,
                        // end_by: DataTypes.INTEGER,
                        start_saldo: saldo,
                        // end_saldo: DataTypes.DECIMAL(10, 2),
                        time_start: new Date(),
                        // time_end: DataTypes.DATE,
                        status: "open",
                    });
                } catch (error) {
                    console.log(error);

                    this.$emit("show-dialog", error.response.data.message);
                    this.$toast.add({
                        severity: "error",
                        summary: "Failed",
                        detail: error.response.data.message,
                        life: 5000,
                    });
                } finally {
                    this.loading = false;
                }
            },
            async stopCashRegister(saldo) {
                try {
                    this.loading = true;
                    this.endBalance = parseInt(saldo);
                    
                    await this.closeCashRegister({
                        id: this.relevantCashRegister.id,
                        // start_by: DataTypes.INTEGER,
                        // end_by: DataTypes.INTEGER,
                        // start_saldo: saldo,
                        end_saldo: saldo,
                        // time_start: new Date(),
                        time_end: new Date(),
                        status: "close",
                    });
                } catch (error) {
                    console.log(error);

                    this.$emit("show-dialog", error.response.data.message);
                    this.$toast.add({
                        severity: "error",
                        summary: "Failed",
                        detail: error.response.data.message,
                        life: 5000,
                    });
                } finally {
                    this.loading = false;
                }
            },
        },
    };
</script>